import { QueryParameters } from "@faire/web-api--source/api/exclusivity-agreements/retailers/retailerToken/availability/get";
import { useQuery as useExclusivityAvailabilityQuery } from "@faire/web-api--source/api/exclusivity-agreements/retailers/retailerToken/availability/get-hooks";

import { getSettingEnableRetailerExclusivityAgreements } from "@faire/retailer/settings/getSettingEnableRetailerExclusivityAgreement";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";

export type Options = Parameters<typeof useExclusivityAvailabilityQuery>["2"];

/**
 * By default:
 * - Options.enabled = getSettingEnableRetailerExclusivityAgreements()
 * - Options.staleTime = 3 * 60 * 1000
 */
export const useExclusivityAvailability = (
  brandToken: string | undefined,
  options?: Options
) => {
  const { retailerToken = "" } = useRetailerStore(["retailerToken"]);
  const { data: availability, ...rest } = useExclusivityAvailabilityQuery(
    retailerToken,
    QueryParameters.build({ brand_token: brandToken, include_options: true }),
    {
      enabled: getSettingEnableRetailerExclusivityAgreements(),
      staleTime: 3 * 60 * 1000,
      ...options,
    }
  );
  return { availability, ...rest };
};
